import {
  JOB_DETAIL,
  JOB_DETAIL_RESULTS_ONLY,
  JOB_PREVIEW,
  JOB_PREVIEW_RESULTS_ONLY,
  JOB_SEARCH_WITH_DETAIL,
  COMPANY_DETAIL,
  COMPANY_DETAIL_BARE,
  COMPANY_SEARCH_WITH_DETAIL,
  JOB_LP,
  COMPANY_LP,
  JOB_SEARCH,
  COMPANY_SEARCH,
  JOBS_GENERIC_LP
} from '@/page/constants'

import defaultState from './defaultState'

const unwrapState = state => state.page || defaultState

/**
 * Returns current page type
 * @param state
 * @return {PageType}
 */
export const getPageType = (state) => unwrapState(state).type

/**
 * Returns true if current page is a job detail or job detail only results
 * @param state
 * @returns {boolean}
 */
export const isJobDetailPage = (state) => [JOB_DETAIL, JOB_DETAIL_RESULTS_ONLY].includes(getPageType(state))

/**
 * Returns true if current page is a job preview or job preview results only
 * @param {*} state
 */
export const isJobPreviewPage = (state) => [JOB_PREVIEW, JOB_PREVIEW_RESULTS_ONLY].includes(getPageType(state))

/**
 * Returns true if current page is a company detail page or company search with detail page
 * @param {*} state
  * @returns {boolean}
 */
export const isCompanyJobmailPage = (state) =>
  [JOB_DETAIL, JOB_SEARCH_WITH_DETAIL, COMPANY_DETAIL, COMPANY_DETAIL_BARE, COMPANY_SEARCH_WITH_DETAIL].includes(getPageType(state))

export const isSearchResultsPage = (state) => [
  JOB_SEARCH,
  COMPANY_SEARCH,
  JOB_DETAIL,
  JOB_SEARCH_WITH_DETAIL,
  COMPANY_DETAIL,
  COMPANY_SEARCH_WITH_DETAIL,
  JOB_LP,
  COMPANY_LP,
  JOBS_GENERIC_LP
].includes(getPageType(state))
